import React, { useState, useEffect, createContext, useContext } from "react";
import AlertMessage from "./AlertMessage";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseUrl } from "./general";

export const phonePriceContext = createContext();

const PhonePriceListContext = ({ children }) => {
  const [alert, setAlert] = useState({
    alertCheck: false,
    status: null,
    message: "",
    severity: "",
  });
  const { t, i18n } = useTranslation();
  const [phoneData, setPhoneData] = useState([]);
  const [laptopData, setLaptopData] = useState([]);
  const [gameData, setGameData] = useState([]);
  const [tabletData, setTabletData] = useState([]);
  const [dasteData, setDasteData] = useState([]);
  const [modemData, setModemData] = useState([]);

  // useEffect(() => {
  //   getPhoneData()
  //   getLaptopData()
  //   getGameData()
  //   const phoneDataInterval = setInterval(() => {
  //     getPhoneData()
  //     getLaptopData()
  //     getGameData()
  //   }, 3600000)
  //   return () => {
  //     clearInterval(phoneDataInterval);
  //   };
  // }, [])
  useEffect(() => {
    const props = ["1", "2", "3", "4", "6", "7"];
    props.forEach((prop) => {
      getProductData(prop);
    });
    const phoneDataInterval = setInterval(() => {
      props.forEach((prop) => {
        getProductData(prop);
      });
    }, 1800000);
    return () => {
      clearInterval(phoneDataInterval);
    };
  }, []);

  // const getPhoneData = () => {
  //   Promise.resolve(axios({
  //     url: baseUrl + '/api/v1/general/getPricePhone',
  //     method: "GET",
  //     params: {
  //       list: "P"
  //     }
  //   }))
  //     .then((res) => {
  //       res.data.data.forEach((element, index) => {
  //         element.key = index
  //       });
  //       setPhoneData(res.data.data)
  //     })
  //     .catch((error) => {
  //       const { status } = error.response;
  //       status === 500 ?
  //         setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
  //         setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
  //     })
  // }

  // const getLaptopData = () => {
  //   Promise.resolve(axios({
  //     url: baseUrl + '/api/v1/general/getPricePhone',
  //     method: "GET",
  //     params: {
  //       list: "L"
  //     }
  //   }))
  //     .then((res) => {
  //       res.data.data.forEach((element, index) => {
  //         element.key = index
  //       });
  //       setLaptopData(res.data.data)
  //     })
  //     .catch((error) => {
  //       const { status } = error.response;
  //       status === 500 ?
  //         setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
  //         setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
  //     })
  // }

  // const getGameData = () => {
  //   Promise.resolve(axios({
  //     url: baseUrl + '/api/v1/general/getPricePhone',
  //     method: "GET",
  //     params: {
  //       list: "G"
  //     }
  //   }))
  //     .then((res) => {
  //       res.data.data.forEach((element, index) => {
  //         element.key = index
  //       });
  //       setGameData(res.data.data)
  //     })
  //     .catch((error) => {
  //       const { status } = error.response;
  //       status === 500 ?
  //         setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
  //         setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
  //     })
  // }

  const getProductData = (prp) => {
    Promise.resolve(
      axios({
        url: baseUrl + "/api/v1/product/get",
        method: "GET",
        params: {
          group: prp,
          prop: "P",
        },
      }),
    )
      .then((res) => {
        switch (prp) {
          case "1":
            setPhoneData(res.data.data);
            break;
          case "2":
            setLaptopData(res.data.data);
            break;
          case "3":
            setTabletData(res.data.data);
            break;
          case "4":
            setGameData(res.data.data);
            break;
          case "6":
            setDasteData(res.data.data);
            break;
          case "7":
            setModemData(res.data.data);
            break;
          default:
            break;
        }
        // console.log(res.data)
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500
          ? setAlert({
              alertCheck: true,
              message: t("AM_intervalServer"),
              severity: "error",
            })
          : setAlert({
              alertCheck: true,
              message: t("alert_dataFaild"),
              severity: "error",
            });
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    return setAlert({
      alertCheck: false,
      message: "",
      severity: alert.severity,
    });
  };

  return (
    <>
      <phonePriceContext.Provider
        value={{
          phoneData,
          laptopData,
          gameData,
          tabletData,
          dasteData,
          modemData,
        }}
      >
        {children}
      </phonePriceContext.Provider>
      <AlertMessage
        open={alert.alertCheck}
        message={alert.message}
        duration={3000}
        close={handleClose}
        severity={alert.severity}
      />
    </>
  );
};

export default PhonePriceListContext;
export const usePrice = () => {
  return useContext(phonePriceContext);
};
